'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = AppRoutes;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

var _SelectLocation = require('./components/SelectLocation');

var _SelectLocation2 = _interopRequireDefault(_SelectLocation);

var _Main = require('./components/Main');

var _Main2 = _interopRequireDefault(_Main);

var _MyAccount = require('./components/account/MyAccount');

var _MyAccount2 = _interopRequireDefault(_MyAccount);

var _MyCart = require('./components/MyCart');

var _MyCart2 = _interopRequireDefault(_MyCart);

var _OrderSuccessMain = require('./components/common/OrderSuccessMain');

var _OrderSuccessMain2 = _interopRequireDefault(_OrderSuccessMain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AppRoutes() {
    return _react2.default.createElement(
        _reactRouterDom.BrowserRouter,
        null,
        _react2.default.createElement(
            _reactRouterDom.Switch,
            null,
            _react2.default.createElement(
                _reactRouterDom.Route,
                { exact: true, path: '/' },
                ' ',
                _react2.default.createElement(_SelectLocation2.default, null),
                ' '
            ),
            ['/location/:locId', '/location/:locId/items/:itemId/'].map(function (path, index) {
                return _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: path, component: _Main2.default, key: index });
            }),
            ["/location/:locId/orders", "/location/:locId/addresses", "/location/:locId/payments", "/location/:locId/orders/profile"].map(function (myAccountPath, index) {
                return _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: myAccountPath, component: _MyAccount2.default, key: index });
            }),
            _react2.default.createElement(
                _reactRouterDom.Route,
                { exact: true, path: '/location/:locId/checkout' },
                ' ',
                _react2.default.createElement(_MyCart2.default, null),
                ' '
            ),
            _react2.default.createElement(
                _reactRouterDom.Route,
                { exact: true, path: '/location/:locId/success' },
                ' ',
                _react2.default.createElement(_OrderSuccessMain2.default, null),
                ' '
            ),
            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '*', component: _SelectLocation2.default })
        )
    );
}


//////////////////
// WEBPACK FOOTER
// ./src/AppRoutes.jsx
// module id = 204
// module chunks = 0